// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3rCzD","item":"PaymentsMobile_item__B9i4t","label":"PaymentsMobile_label__2LOpk","amount":"PaymentsMobile_amount__1exQw"};